import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { get, post } from 'helpers/api';
import SignCaPdf from './sign_ca_pdf';
import SignCaText from './sign_ca_text';
import { getProfileData } from '../../helpers/preview';
import LoadingSpinner from 'components/ui/loading_spinner';

export default function SignCa({
  caPath,
  readonly,
  signCaPath,
  trackViewedCaPath,
  onNext,
}) {
  const [caData, setCaData] = useState({
    caFilePath: '',
    caText: '',
    caType: '',
    requiredName: ''
  });

  React.useEffect(() => {
    const pathName = window.location.pathname;
    const hasViewed = sessionStorage.getItem(`viewed_ca_${pathName}`);

    if (!hasViewed) {
      post(trackViewedCaPath).then(() => {
        sessionStorage.setItem(`viewed_ca_${pathName}`, true);
      });
    }

    get(caPath, { params: { readonly, previewProfile: getProfileData() } })
      .then((data) => {
        const {
          ca, file, caType, requiredName, caTypeStandard, caTypeCustomText, caTypeCustomPdf, caTypeCustomWord
        } = data;
        setCaData({
          caText: ca,
          caFilePath: file,
          caType,
          requiredName,
          caTypeStandard,
          caTypeCustomText,
          caTypeCustomPdf,
          caTypeCustomWord
        });
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('fetch ca failed', { message: error.message, data: error.response.data });
      });
  }, []);

  const { caFilePath, caText, caType, requiredName } = caData;

  if (!caText && !caFilePath) {
    return (
      <div className="text-center">
        <LoadingSpinner />
      </div>
    );
  }

  if (caFilePath) {
    return (
      <SignCaPdf
        caFiles={[{ type: caType, path: caFilePath }]}
        readonly={readonly}
        signCaPath={signCaPath}
        onNext={onNext}
      />
    );
  } else {
    return (
      <SignCaText
        caText={caText}
        name={requiredName}
        readonly={readonly}
        signCaPath={signCaPath}
        onNext={onNext}
      />
    );
  }
}

SignCa.propTypes = {
  caPath: PropTypes.string.isRequired,
  readonly: PropTypes.bool,
  signCaPath: PropTypes.string.isRequired,
  onNext: PropTypes.func.isRequired
};
